const // extremas used in bbox calculation and similar algorithms
nMax = Number.MAX_SAFE_INTEGER || 9007199254740991;
const nMin = Number.MIN_SAFE_INTEGER || -9007199254740991;
export const getminmax = (curve, dim, list) => {
    if (!list) {
        return { min: 0, max: 0 };
    }
    let min = nMax;
    let max = nMin;
    let t;
    let cAtT;
    if (list.indexOf(0) === -1) {
        list = [0].concat(list);
    }
    if (list.indexOf(1) === -1) {
        list.push(1);
    }
    for (let i = 0, len = list.length; i < len; i += 1) {
        t = list[i];
        cAtT = curve.get(t);
        if (cAtT[dim] < min) {
            min = cAtT[dim];
        }
        if (cAtT[dim] > max) {
            max = cAtT[dim];
        }
    }
    return { min, mid: (min + max) / 2, max, size: max - min };
};
export const numberSort = (v1, v2) => v1 - v2;
